export default __webpack_public_path__ + "c26eeb3bf741d5a2e325912d0c8e31da.png";